import { useSearchParams } from "react-router-dom";
import Reviews from "../components/Reviews";
import { parseReviewOrderId } from "../utils/reviewOrderLink";

export default function ReviewPage() {
  const [searchParams] = useSearchParams();
  const rentalRequestId = parseReviewOrderId(searchParams.get("order"));

  return (
    <main className="relative">
      {/* Extra bakgrunds-yta i toppen */}
      <div
        className="
          absolute
          top-0 left-0 right-0
          h-32
          bg-gradient-to-r from-purple-600 to-blue-700
          z-0
        "
      />

      {/* Innehållet */}
      <div className="relative z-10 pt-20 md:pt-16">
        <Reviews initialShowForm rentalRequestId={rentalRequestId} />
      </div>
    </main>
  );
}
